const NetworkError = () => {
  return (
    <>
      <img src="/network-error.png" alt="network error" />
    </>
  );
};

export default NetworkError;
